import Vue from "vue";
import Router from "vue-router";

const TheContainer = () => import("@/components/TheContainer");
const Home = () => import("@/views/Home.vue");
const Profile = () => import("@/views/Profile.vue");
const EditProfile = () => import("@/views/EditProfile.vue");
const MyOrder = () => import("@/views/MyOrder.vue");
const Subcription = () => import("@/views/Subcription.vue");
const DeliveryAddressList = () => import("@/views/DeliveryAddressList.vue");
const ContactUs = () => import("@/views/ContactUs.vue");
const Wallet = () => import("@/views/Wallet.vue");
const HelpSupport = () => import("@/views/HelpSupport.vue");
const Register = () => import("@/views/Register.vue");
const EnterOtp = () => import("@/views/EnterOtp.vue");
const RegisterProfile = () => import("@/views/RegisterProfile.vue");
const Notification = () => import("@/views/Notification.vue");
const Cart = () => import("@/views/Cart.vue");
const Product = () => import("@/views/Product.vue");
const Productdetail = () => import("@/views/Productdetail.vue");
const Calender = () => import("@/views/Calender.vue");
const Subcategory = () => import("@/views/Subcategory.vue");
const AddMoney = () => import("@/views/AddMoney.vue");
const AddNewAddress = () => import("@/views/AddNewAddress.vue");
const TransactionDetails = () => import("@/views/TransactionDetails.vue");
const ProductSubscription = () => import("@/views/ProductSubscription.vue");
const ProductPause = () => import("@/views/ProductPause.vue");
const Productdetailsingle = () => import("@/views/Productdetailsingle.vue");
const PaymentMethod = () => import("@/views/PaymentMethod.vue");
const NotFound = () => import("@/views/404.vue");
const Pinlocation = () => import("@/views/PinLocation.vue");
const PrivacyPolicy = () => import("@/views/PrivacyPolicy.vue");
const PaymentOptions = () => import("@/views/PaymentScreen.vue");

Vue.use(Router);

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/home",
      name: "homeCon",
      component: TheContainer,
      // beforeEnter: listResolver,
      children: [
        {
          path: "/",
          name: "home",
          component: Home
          // meta: list,
          // beforeEnter: listResolver
        },
        {
          path: "/register",
          name: "register",
          component: Register
        },
        {
          path: "/enter-otp",
          name: "enter-otp",
          component: EnterOtp
        },
        {
          path: "/register-profile",
          name: "register-profile",
          component: RegisterProfile
        },
        {
          path: "/location",
          name: "location",
          component: Pinlocation
        },

        {
          path: "/404",
          name: "404page",
          component: NotFound
        },

        {
          path: "/profile",
          name: "profile",
          component: Profile,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/edit-profile",
          name: "edit-profile",
          component: RegisterProfile,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/edit-location",
          name: "edit-location",
          component: Pinlocation
        },
        {
          path: "/add-new-address",
          name: "add-new-address",
          component: AddNewAddress,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/my-order",
          name: "my-order",
          component: MyOrder,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/subcription",
          name: "subcription",
          component: Subcription,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/activate-subscription",
          name: "activate-subscription",
          component: ProductPause,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/product-subscription",
          name: "product-subscription",
          component: ProductSubscription,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/payment",
          name: "payment",
          component: PaymentOptions,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/delivery-address-list",
          name: "delivery-address-list",
          component: DeliveryAddressList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/contact-us",
          name: "contact-us",
          component: ContactUs
        },
        {
          path: "/wallet",
          name: "wallet",
          component: Wallet,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/transaction-detail",
          name: "transaction-detail",
          component: TransactionDetails,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/add-money",
          name: "add-money",
          component: AddMoney,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/help-support",
          name: "help-support",
          component: HelpSupport
        },

        {
          path: "/notification",
          name: "notification",
          component: Notification,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/privacy-policy",
          name: "privacy-policy",
          component: PrivacyPolicy
        },
        {
          path: "/about-us",
          name: "about-us",
          component: PrivacyPolicy
        },
        {
          path: "/terms-and-conditions",
          name: "terms-and-conditions",
          component: PrivacyPolicy
        },
        {
          path: "/refund-policy",
          name: "refund-policy",
          component: PrivacyPolicy
        },
        {
          path: "/cart",
          name: "cart",
          component: Cart,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/productdetail",
          name: "productdetail",
          component: Productdetail,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/:subcategoryname",
          name: "subcategory",
          component: Subcategory,
          meta: {
            title: "About Page - Example App",
            metaTags: [
              {
                name: "description",
                content: "The about page of our example app."
              },
              {
                property: "og:description",
                content: "The about page of our example app."
              }
            ]
          }
        },
        {
          path: "/:categoryname/:name",
          name: "product",
          component: Product
        },

        {
          path: "/calender",
          name: "calender",
          component: Calender,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "/:categoryname/:subcategoryName/:name",
          name: "productdetailsingle",
          component: Productdetailsingle,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/payment-method",
          name: "payment-method",
          component: PaymentMethod,
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ];
}
const router = new Router({
  mode: "history",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
});
router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.path)) {
    next({
      path: "/404"
    });
  } else {
    next();
  }
});

// const listResolver = async (to, from, next) => {
//   console.log("test")
//   const dataManager = new DataManager();
//   to.meta["list"] = await dataManager.getList(to.params["id"]);
//   next();
// };

export default router;
